jQuery(function($) {
	var $html = $('html').removeClass('no-js');

	$html.deepLinks();
	$('form input[id^="your-name_"]').remove();
	
	$('select[multiple]').multiselect();


	// ADD ALL YOUR CUSTOM JS THINGS AFTER THIS LINE

	/**
	 * add id "page-title" to very first headline we find
	 */
	let pageTitle = document.querySelectorAll('h1, h2, h3, h4, h5, h6');
	if(pageTitle.length) {
		// find first visible headline
		pageTitle = Array.from(pageTitle).find(h => h.offsetHeight);
		if(pageTitle) {
			pageTitle.id = 'page-title';
		}
	}

	$('.navigation').each(function() {
		var $anchornav = $(this),
			$header = $('header').eq(0);

		$(document).on('scroll', function () {
			var offcanvas = $header.height() === $(window).height(),
				metaHeight = ($('.meta-navigation').height() || 0) + 40,
				headerHeight = (['sticky', 'fixed'].indexOf($header.css('position')) > -1 && !offcanvas ? $header.height() : 0) + 10 + metaHeight,
				scrollPos = $(document).scrollTop() + headerHeight + ($anchornav.is('[data-offset]') ? parseInt($anchornav.attr('data-offset')) : 0),
				$links = $anchornav.find('li').removeClass('active-item').find('a').filter(function() {
					var href = $(this).attr('href');

					if(href.indexOf('#') < 0) {
						return false;
					}

					var $marker = $('#' + href.split('#').pop());

					return !!($marker.length && href.indexOf('#') > -1 && scrollPos >= $marker.offset().top);
				});

			$links.eq(-1).parents('li').addClass('active-item');

			if($links.eq(-1).parents('li.active-item')) {
				$('#hamburgerToggle').addClass('active-item');
			}
		}).trigger('scroll');
	});

	/**
	 * On click on a link in .container-header, close the menu (toggle checked attribute of input[type="checkbox"])
	 */
	$('.container-header').on({
		click: function() {
			$('.container-header input[type="checkbox"]').prop('checked', false);
		}
	}, 'a');

	/**
	 * add listeners for jumpnavigation between posts of history
	 */
	$('.article__nav').historyNav();

	$('.scroll-top-button').on({
		click: function() {
			$(document).scrollTop(0);
			return false;
		}
	});

	// on [cmd]+[g] add debug class to container-content
	let $content = $('.container-content');
	$(document).on('keydown', function(e) {
		if(e.key === 'g' && e.metaKey) {
			$content.toggleClass('debug');
			// add state to local storage
			sessionStorage.setItem('debug', $content.hasClass('debug'));

			return false;
		}
	});
	// check local storage for debug state
	if(sessionStorage.getItem('debug') === 'true') {
		$content.addClass('debug');
	}
});
